export const REQUEST_TIMEOUT = 30000;

export const DEFAULT_ERROR = {
  message: 'Request has been failed',
  code: 500,
};

export const TIMEOUT_ERROR = {
  message: 'Your request is failed due to timeout',
  code: 500,
};
